import React from "react";

import { Image, Text, View, StyleSheet } from "@react-pdf/renderer";

import { siLogoBase64 } from "../../assets/icon/siLogo";

const asgmtHeaderStyle = StyleSheet.create({
	dateColumn: {
		position: "absolute",
		left: 507,
		top: 131,
		alignItems: "flex-end",
	},
	yearLevel: {
		position: "relative",
		top: 7,
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "normal",
		fontSize: 20,
		letterSpacing: 0.25,
	},
	date: {
		position: "relative",
		top: 38,
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "normal",
		fontSize: 20,
		letterSpacing: 0.25,
	},
	title: {
		position: "absolute",
		left: 49,
		top: 47,
		fontFamily: "Public Sans",
		fontStyle: "normal",
		fontWeight: "medium",
		fontSize: 36,
		color: "#09203F",
	},
	name: {
		position: "absolute",
		left: 49,
		top: 126,
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "medium",
		fontSize: 32,
	},
	image: {
		position: "absolute",
		width: "15%",
		left: 610,
		top: 47,
	},
});

interface HeaderProps {
	name: string;
	yearLevel: string;
	date: string;
}

export const AssignmentHeader = ({
	name,
	yearLevel,
	date,
}: HeaderProps): JSX.Element => {
	return (
		<>
			<View style={asgmtHeaderStyle.dateColumn}>
				<Text style={asgmtHeaderStyle.yearLevel}>Year level: {yearLevel}</Text>
				<Text style={asgmtHeaderStyle.date}>Report Date: {date}</Text>
			</View>
			<Text style={asgmtHeaderStyle.title}>Science Island Student Report</Text>
			<Text style={asgmtHeaderStyle.name}>{name}</Text>
			<Image
				style={asgmtHeaderStyle.image}
				// Due to unknown reason, Science Island logo cannot be recognized by <Image /> component
				// we have to convert image to base64 string, and it will be rendered
				src={`data:image/png;base64, ${siLogoBase64}`}
			/>
		</>
	);
};
